import { render, staticRenderFns } from "./feeAdvanceReceiptDetailQuery.vue?vue&type=template&id=63e422b2&"
import script from "./feeAdvanceReceiptDetailQuery.vue?vue&type=script&lang=js&"
export * from "./feeAdvanceReceiptDetailQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports